import type {ReactElement} from 'react';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import styles from './publishing-options-buttons.module.scss';

export function PublishingOptionsButtons(): ReactElement<any> {
  return (
    <div className={`flex-row-align-center spacing-p-t-0 spacing-p-b-0 spacing-p-l-1 spacing-p-r-1 ${styles.buttonGap}`}>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        overlay={<Tooltip className="spacing-m-b-2">Refresh Session</Tooltip>}
        delay={{show: 0, hide: 0}}
        placement="top"
        popperConfig={undefined}
        show={undefined}
        defaultShow={undefined}
        onHide={undefined}
        onToggle={undefined}
        target={undefined}
        flip={undefined}
        offset={undefined}
      >
        <Icon icon="icon-rotate-ccw" className="content-disabled-dark _cursor-pointer radius-round spacing-p-2 border-s-darker" size={IconSize.SIZE_ICON_16} />
      </OverlayTrigger>
    </div>
  );
}
